import { HotspotType } from './hotspot-type.model';

export class Hotspot {

  public id: string;
  public latitude: number;
  public longitude: number;
  public savedLatitude: number;
  public savedLongitude: number;
  public radius = 1000;
  public type: HotspotType;
  public label: string;
  public address: string;
  public country: string;
  public countryCode: string;

  public markerNormalUrl: string;
  public markerSelectedUrl: string;

  static fromDto(h): Hotspot {
    const hotspot          = new Hotspot();
    hotspot.id             = h.id;
    hotspot.latitude       = h.latitude;
    hotspot.longitude      = h.longitude;
    hotspot.savedLatitude  = h.latitude;
    hotspot.savedLongitude = h.longitude;
    hotspot.radius         = h.radius;
    hotspot.type           = h.type;
    hotspot.label          = h.label;
    hotspot.address        = h.address;
    hotspot.country        = h.country;
    hotspot.countryCode    = h.countryCode;

    hotspot.markerNormalUrl = hotspot.type;

    switch (hotspot.type) {
      case HotspotType.SERVICE_CENTER:
        hotspot.markerNormalUrl   = '/assets/marker-service-center-normal.png';
        hotspot.markerSelectedUrl = '/assets/marker-service-center-selected.png';
        break;
      case HotspotType.CUSTOMER:
        hotspot.markerNormalUrl   = '/assets/marker-customer-normal.png';
        hotspot.markerSelectedUrl = '/assets/marker-customer-selected.png';
        break;
      default:
        hotspot.markerNormalUrl   = '/assets/marker-recycler-normal.png';
        hotspot.markerSelectedUrl = '/assets/marker-recycler-selected.png';
    }

    return hotspot;
  }
}
